const jobs = {
  title: 'Job Management',
  projectsTitle: 'Recruiting Projects',
  projectsSubtitle:
    'Each conversation maps to one recruiting project. Continue into Agent chats or manage candidates.',
  filterProjects: 'Filter Projects',
  allJobs: 'All Jobs',
  openJobs: 'Open Jobs',
  closedJobs: 'Closed Jobs',
  draftJobs: 'Draft',
  searchPlaceholder: 'Search by job_name / Search by name',
  batchParseVip: 'Bulk JD Import',
  jobProfileCol: 'Job Name',
  projectSessionCol: 'Project / Conversation',
  jobTalentCol: 'Job Talent',
  recommendedTalentCol: 'Recommended Talent',
  statusCol: 'Status',
  candidateTotalCol: 'Candidates',
  openToWorkCol: 'open to work',
  matchedTalentCol: 'Qualified Matches',
  localImport: 'Import Resumes',
  talkToAi: 'Talk to AI',
  agentEdit: 'Agent Edit',
  agentAction: 'Agent',
  jobTalentAction: 'Job Talent',
  talentRecommendAction: 'Talent Recs',
  linkedinSearch: 'LinkedIn Search',
  bindCandidate: 'Bind Candidates',
  moreAction: 'More',
  backToTop: 'Back to top',
  statusTagOpen: 'Open Job',
  statusTagClosed: 'Paused',
  statusTagDraft: 'Draft',
  projectStatusOpen: 'In Progress',
  projectStatusClosed: 'Paused',
  projectStatusDraft: 'Draft',
  continueImport: 'LinkedIn Search',
  continueEdit: 'Continue Editing',
  openDraft: 'Open',
  recommendTag: 'AI Recommended',
  processingTag: 'Processing',
  openAtLabel: 'Job Open Time',
  closeAtLabel: 'Job Close Time',
  talentRecommendations: {
    titlePrefix: 'Recommended',
    titleSuffix: 'candidates for you',
    partialSubtitle: 'Still looking for more candidates. Results already found will appear first.',
    completedSubtitle: 'Candidate recommendations are ready based on your current filters.',
    cacheSubtitle: 'Showing your most recent recommendation results',
    runningSubtitle: 'Matching candidates based on this search strategy',
    refresh: 'Recommend More',
    // C1 / C2: people meeting the hard conditions, and how many are shown.
    matchTotal: 'Talent pool: {count}',
    matchTotalCapped: 'Talent pool: 1k+',
    shownCount: '{count} recommended',
    refreshConfirmTitle: 'Recommend More Candidates',
    refreshConfirmDescription:
      'Your existing {existing} candidates will be kept. This adds up to {count} more and consumes {points} AI Credits.',
    refreshConfirmButton: 'Add Candidates',
    refreshRunningTitle: 'Adding candidates',
    refreshRunningDesc:
      'Existing results stay visible while new candidates are added automatically.',
    refreshSuccess: 'Added {count} candidates. {total} candidates are now available.',
    refreshFailed: 'Failed to add candidates',
    locked: 'Locked',
    lockedBasicInfo: 'Basic information is masked',
    aiMatchExhaustedTitle: 'Insufficient AI Credits',
    aiMatchExhaustedDescription:
      '{count} candidates are still locked. Each candidate costs 2 AI Credits. After upgrading, return to this page and the system will unlock as many as the available balance allows; any remainder stays locked.',
    upgradeMembership: 'Upgrade Membership',
    aiMatchUnlockSuccess:
      'Unlocked {count} candidates at 2 credits each, using {points} AI Credits.',
    aiMatchUnlockPartial:
      'Unlocked {unlocked} candidates using {points} AI Credits. The balance was insufficient, so {locked} candidates remain locked (2 credits each).',
    aiMatchUnlockNone:
      'Insufficient AI Credits. {locked} candidates remain locked (2 credits each).',
    addAll: 'Add All to Job',
    allAdded: 'All Added to Job',
    criteria: 'Criteria',
    noCriteria: 'No criteria yet',
    adjustCriteria: 'Edit filters',
    filtersTitle: 'Edit Your Search Filters',
    filterSavedState: 'Saved filters',
    filterDraftState: 'Unsaved filters',
    filterSearchPlaceholder: 'Search filters',
    filterHideInactive: 'Hide inactive filters',
    filterMatchCount: '{count} matches',
    filtersGeneral: 'General',
    filtersCore: 'Core filters',
    filtersSignals: 'Match signals',
    filtersLocations: 'Locations',
    filtersJob: 'Job',
    filtersCompany: 'Company',
    filtersSkills: 'Skills and Keywords',
    filtersEducation: 'Education',
    filtersLanguages: 'Languages',
    filtersPower: 'Advanced filters',
    filtersScoring: 'Scoring',
    filtersExcludeRisk: 'Exclude',
    filterRole: 'Role',
    filterRolePlaceholder: 'Example: Backend Engineer',
    filterIndustry: 'Industry',
    filterIndustryPlaceholder: 'Example: AI SaaS',
    filterIndustries: 'Industry tags',
    filterSeniority: 'Seniority',
    filterSeniorityPlaceholder: 'Example: Senior',
    filterSeniorityLevels: 'Seniority',
    filterRoleTypes: 'Role types',
    filterJobFunctions: 'Job functions',
    filterExperience: 'Experience',
    filterAge: 'Age',
    filterExperiencePlaceholder: 'Example: 3-8 years',
    filterRangeMinPlaceholder: 'Min',
    filterRangeMaxPlaceholder: 'Max',
    filterRangeSeparator: 'to',
    filterYearsInCurrentRole: 'Years in current role',
    filterRecentlyChangedJobs: 'Recently changed jobs',
    filterJobChangeFrequency: 'Job change frequency',
    filterTitles: 'Job titles',
    filterExcludeJobTitles: 'Exclude titles',
    filterCurrentTitleOnly: 'Current title only',
    filterRecentWorkTitleOnly: 'Recent work experience title',
    filterIncludeRelatedTitles: 'Include related titles',
    filterMatchExperience: 'Match experience scope',
    filterKeywords: 'Keywords',
    filterSkills: 'Skills',
    filterSkillsAndKeywords: 'Skills and keywords',
    filterLocations: 'Locations',
    filterCurrentWorkLocations: 'Current work locations',
    filterPastWorkLocations: 'Past work locations',
    filterLocationRadius: 'Location radius',
    filterLocationRadiusPlaceholder: '1-500 miles',
    filterCompanies: 'Target companies',
    filterCompanyEvidence: 'Target company',
    filterTargetCompanySearchPlaceholder: 'Search target companies',
    filterExcludeCompanySearchPlaceholder: 'Search excluded companies',
    filterCompanySearchMore: 'Search for another company',
    filterCompanyNoResults: 'No matching company in candidate experience',
    filterCompanyRelated: 'Related',
    filterCompanyLegacy: 'Unconfirmed',
    filterCompanyFilter: 'Company match scope',
    filterCurrentCompanyOnly: 'Current company only',
    filterExcludeCompanies: 'Exclude companies',
    filterExcludeCompanyFilter: 'Exclude company scope',
    filterDomains: 'Company domains',
    filterSchools: 'Schools',
    filterEducationDegrees: 'Degrees',
    filterEducationMajors: 'Majors',
    filterLanguages: 'Languages',
    filterLanguageProficiencies: 'Language proficiency',
    filterAnyProficiencyLevel: 'Any Proficiency Level',
    filterLanguageInputPlaceholder: 'Example: English, Spanish, Mandarin, etc.',
    filterLanguageSelectPlaceholder: 'Select common languages',
    filterIsChinese: 'Chinese identity',
    filterHasChinaExperience: 'China company / China experience',
    filterMustHave: 'Must-have',
    filterPreferred: 'Preferred',
    filterResearchTopics: 'Research topics',
    filterExclude: 'Exclude',
    filterRisk: 'Risk signals',
    filterListPlaceholder: 'One per line, or comma separated',
    filterTagPlaceholder: 'Type and press Enter',
    filterSelectPlaceholder: 'Select options',
    filterAnyPlaceholder: 'Any',
    filterOptionJunior: 'Junior',
    filterOptionMid: 'Mid-level',
    filterOptionSenior: 'Senior',
    filterOptionLead: 'Lead',
    filterOptionManager: 'Manager',
    filterOptionDirector: 'Director',
    filterOptionExecutive: 'Executive',
    filterOptionMax3JobsIn5Years: 'Max 3 jobs in 5 years',
    filterOptionMax2JobsIn3Years: 'Max 2 jobs in 3 years',
    filterOptionMin2YearsInLast2Jobs: 'Min 2 years in last 2 jobs',
    filterOptionNoLimit: 'No limit',
    filterOptionIC: 'Individual contributor',
    filterOptionFrontlineManager: 'Frontline manager',
    filterOptionFunctionalLeader: 'Functional leader',
    filterOptionBusinessOwner: 'Business owner',
    filterOptionEngineering: 'Engineering',
    filterOptionProduct: 'Product',
    filterOptionSales: 'Sales',
    filterOptionMarketing: 'Marketing',
    filterOptionHumanResources: 'Human resources',
    filterOptionFinance: 'Finance',
    filterOptionOperations: 'Operations',
    filterOptionCustomerSuccess: 'Customer success',
    filterOptionDesign: 'Design',
    filterOptionData: 'Data',
    filterOptionLegal: 'Legal',
    filterOptionSupplyChain: 'Supply chain',
    filterOptionConsulting: 'Consulting',
    filterOptionElementaryProficiency: 'Elementary proficiency',
    filterOptionLimitedWorkingProficiency: 'Limited working proficiency',
    filterOptionProfessionalWorkingProficiency: 'Professional working proficiency',
    filterOptionFullProfessionalProficiency: 'Full professional proficiency',
    filterOptionNativeBilingualProficiency: 'Native or bilingual proficiency',
    filterOptionCurrent: 'Current experience',
    filterOptionPast: 'Past experience',
    filterOptionPastOnly: 'Past experience only',
    filterOptionBoth: 'Current and past experience',
    saveFilters: 'Save Changes',
    saveFiltersSuccess: 'Filters saved. New recommendations will use the updated filters.',
    saveFiltersFailed: 'Failed to save filters',
    loadFiltersFailed: 'Failed to load filters',
    filterValidationFailed: 'Complete the filter first: {reason}',
    filterValidationRoleRequired: 'Role cannot be empty',
    filterValidationPositionSignalRequired: 'Keep at least one title or job function',
    filterValidationMatchSignalRequired:
      'Keep at least one skill keyword, target company, or must-have condition',
    filterValidationCompanyScopeRequiresCompany:
      'Select a target company before choosing a company match scope',
    filterValidationExcludeScopeRequiresCompany:
      'Select an excluded company before choosing an exclusion scope',
    filterValidationLanguageLevelRequiresLanguage:
      'Select a language before choosing a proficiency level',
    jobNotReadyTitle: 'Add a bit more job detail',
    jobNotReadyDesc:
      'There is not enough information for stable talent recommendations yet. Add the role title, location, experience, or keywords and try again.',
    continueDialogue: 'Continue Chat',
    candidateCount: '{count} candidates',
    enriching: 'Searching',
    sourceWarning: 'Some information is still updating',
    sortLabel: 'Recommendation sort',
    sortScore: 'Match',
    sortSource: 'Source',
    sortStatus: 'Status',
    localLoading: 'Looking for suitable candidates',
    emptyTitle: 'No matching candidates yet',
    emptyDesc: 'Try broadening the filters and run recommendations again',
    failedTitle: 'Recommendations are temporarily unavailable',
    failedDesc: 'Please try again later or broaden the filters.',
    loadFailed: 'Unable to load recommended candidates. Please try again.',
    pollFailed: 'Unable to update recommendation results. Please try again.',
    recommendationAlreadyRunning:
      'Recommendations are already being prepared. Please wait a moment.',
    bindSuccess: 'Added to job',
    bindOneSuccess: 'Candidate added to job',
    bindFailed: 'Failed to add to job',
    detailExpired: 'This recommendation result has expired. Refresh the recommendation list.',
    detailLoadFailed: 'Failed to load candidate details',
    unlockContact: 'Unlock Contact',
    unlockContactWithCost: 'Unlock for {count} contact points',
    unlockContactSuccess: 'Contact details unlocked',
    unlockContactFailed: 'Failed to unlock contact details',
    unlockContactInsufficient: 'Insufficient contact points. Purchase or upgrade to unlock.',
    insufficientContactPoints: 'Insufficient contact points',
    noUnlockableContact: 'No unlockable contact details',
    verified: 'Verified',
    reviewPending: 'Needs Review',
    newCandidate: 'New',
    source: 'Source',
    match: 'Match',
    added: 'Added to Job',
    summary: 'Profile Summary',
    noSummary: 'No summary yet. Open the profile to view public source information.',
    missing: 'Missing',
    add: 'Add to Job',
    openSource: 'Open Source',
    sourceLocal: 'Talent Pool',
    sourceAcademic: 'AI Search',
    sourceContactout: 'AI Search',
    unnamedCandidate: 'Unnamed Candidate',
    detailSections: {
      basic: 'Basic Info',
      work: 'Work Experience',
      education: 'Education',
      contact: 'Contact',
      projects: 'Projects',
      evidence: 'Match Evidence',
      sources: 'Data Sources',
    },
    detailFields: {
      name: 'Name',
      full_name: 'Name',
      candidate_name: 'Candidate',
      title: 'Title',
      headline: 'Headline',
      current_title: 'Current Title',
      current_company: 'Current Company',
      company: 'Company',
      organization: 'Organization',
      location: 'Location',
      city: 'City',
      country: 'Country',
      summary: 'Summary',
      bio: 'Bio',
      description: 'Description',
      profile_url: 'Profile URL',
      url: 'URL',
      linkedin_url: 'LinkedIn',
      start_date: 'Start Date',
      end_date: 'End Date',
      school: 'School',
      degree: 'Degree',
      major: 'Major',
      email: 'Email',
      phone: 'Phone',
      source: 'Source',
      candidate_id: 'Candidate ID',
      role: 'Current Role',
      score: 'Match Score',
      match_level: 'Match Level',
      work_experience: 'Total Experience',
      work_experience_no_gap: 'Continuous Experience',
      birth_year: 'Birth Year',
      is_chinese: 'Chinese Candidate',
      working_status: 'Working Status',
      function_id: 'Function ID',
      organization_id: 'Organization ID',
      institution_id: 'Institution ID',
      major_id: 'Major ID',
      employment_type: 'Employment Type',
      location_type: 'Location Type',
      work: 'Work Record',
      project: 'Project Evidence',
      publicSource: 'Public Source',
      open: 'Open',
      present: 'Present',
    },
  },
  newMatchTag: 'New Matched Talent',
  pendingTag: 'Pending',
  batchParseDialog: {
    title: 'Batch Parse Jobs',
    heroTitle: 'Validate first, preview second, import last',
    heroDesc:
      'This kind of Excel is usually a job tracker, not a clean JD source. It is safer to detect headers, preview parsed rows, and let HR confirm before import.',
    heroTip:
      'Default parsing is aligned to your sample sheet: job name, responsibilities, report line, team plan, salary range, role background, core capability request, and HR contact.',
    uploadTitle: 'Upload Job Excel',
    uploadDesc:
      'Supports .xlsx / .xls. The first sheet will be read and common tracker headers will be auto-detected.',
    uploadDropTitle: 'Drop an Excel file here or click to select',
    uploadDropDesc: 'Best results come from one job per row with complete headers',
    sheetName: 'Sheet: {name}',
    statsTitle: 'Parsing Overview',
    reset: 'Reset',
    totalRows: 'Detected rows',
    readyRows: 'Ready to import',
    warningRows: 'Need review',
    skippedRows: 'Skipped',
    selectReady: 'Select importable rows',
    clearSelection: 'Clear selection',
    previewTitle: 'Job Preview',
    previewDesc:
      'Review the full list on the left and the generated profile of the current row on the right.',
    generatedProfile: 'Generated job profile',
    empty: 'Upload an Excel file to begin',
    invalidFile: 'Please upload an Excel file (.xlsx / .xls)',
    parseSuccess: 'Detected {count} job rows',
    parseFailed: 'Failed to parse the Excel file. Please check the format and headers.',
    footerHint: '{count} job(s) selected for import',
    importAction: 'Import {count} job(s)',
    importSuccess: 'Imported {count} job(s) into the list',
    selectAtLeastOne: 'Select at least one job row',
    unnamedJob: 'Untitled job',
    columns: {
      row: 'Row',
      status: 'Status',
      jobName: 'Job Name',
      location: 'Location',
      salary: 'Salary',
      profile: 'Parsed Job Profile',
      hr: 'HR Contact',
      reportTo: 'Report To',
    },
    status: {
      ready: 'Ready',
      warning: 'Review',
      skipped: 'Skipped',
    },
  },
  externalLinkDialog: {
    title: 'Choose your LinkedIn account type',
    destination:
      'Choose the entry that matches your LinkedIn account type to open the search page:',
    linkedin: 'LinkedIn Personal / Business (Business)',
    salesNavigator: 'LinkedIn Sales (Sales)',
    recruiterSearch: 'LinkedIn Recruiter (Recruiter)',
  },
  matchRatingFilter: 'Match Score',
  matchRatingSelected: '{count} selected',
  aiAnalysis: 'AI Search',
  analysisPendingTitle: 'Queued for analysis',
  analysisPendingHint:
    'This profile is in the queue. Results will appear automatically once ready.',
  analysisReAnalyzingTitle: 'Re-analyzing',
  analysisReAnalyzingHint:
    'The job was updated. Matching analysis will refresh on the 5-minute task cycle.',
  analysisNotPointsTitle: 'Not enough points',
  analysisNotPointsHint:
    'The analysis task found insufficient points. Add points and trigger analysis again.',
  analysisNotVipTitle: 'Insufficient match credits',
  analysisNotVipHint:
    'The analysis task found insufficient AI match credits. Add credits and trigger analysis again.',
  analysisAnalyzingTitle: 'AI analyzing',
  analysisAnalyzingHint: 'Generating analysis from the job requirements and candidate background.',
  analysisFailedTitle: 'Analysis failed',
  analysisFailedHint: 'The analysis task did not complete. Try again later or refresh.',
  analysisOldJdHint:
    'This result was generated from an older JD. It will update after re-analysis completes.',
  analysisDelayedTitle: 'Analysis is taking longer',
  analysisDelayedHint:
    'Results usually return within 10 minutes. You can check back later or refresh now.',
  feedback: {
    title: 'AI Feedback',
    agreeTitle: 'Agree',
    agreeTitleWithIcon: '👍 Agree',
    disagreeTitle: 'Disagree',
    disagreeTitleWithIcon: '👎 Disagree',
    reasonLabel: 'Reason',
    customLabel: 'Additional comment',
    customPlaceholder: 'Enter your comment',
    selectReason: 'Please select a reason',
    customRequired: 'Please enter a comment',
    completed: 'Reviewed',
    submitSuccessAgree: 'Positive feedback submitted',
    submitSuccessDisagree: 'Negative feedback submitted',
    options: {
      agree: {
        domainFit: 'Domain / industry fit',
        businessFit: 'Business scenario fit',
        experienceFit: 'Experience relevance',
        strongPerformance: 'Strong past performance',
        preferredMatch: 'Preferred criteria match',
        other: 'Other',
      },
      disagree: {
        domainMismatch: 'Domain / industry mismatch',
        missingRequiredExperience: 'Missing key required experience',
        experienceLevelMismatch: 'Experience level mismatch',
        roleMismatch: 'Role mismatch',
        redFlagTriggered: 'red flag triggered',
        other: 'Other',
      },
    },
  },
  create: 'Create Project',
  name: 'Job Name',
  description: 'Job Description',
  status: 'Status',
  actions: 'Actions',
  view: 'View',
  aiMailAction: 'AI InMail',
  pipelineAdvance: 'Next Stage',
  edit: 'Edit Project',
  rename: 'Rename',
  open: 'Open Job',
  close: 'Close Job',
  retry: 'Retry Analysis',
  delete: 'Delete',
  jd: 'Job JD',
  createTitle: 'Create Project',
  editTitle: 'Edit Project',
  detailTitle: 'Job Detail',
  resumeSummaryEntry: 'Resume Summary',
  resumeSummaryPending: 'Resume summary entry is ready. Backend API will be connected later.',
  resumeSummaryBack: 'Back to candidates',
  resumeSummaryOverview: 'Job Overview',
  resumeSummaryCandidateCount: 'Candidates',
  resumeSummaryAverageScore: 'Average Match Score',
  resumeSummaryAverageExperience: 'Average Experience',
  resumeSummaryProcessDistribution: 'Pipeline Distribution',
  resumeSummaryAllCandidates: 'Candidate Resume Summary',
  resumeSummaryEmpty: 'No resume data is available for this job yet.',
  resumeSummaryLoadFailed: 'Failed to load the resume summary.',
  resumeSummaryContact: 'Contact',
  resumeSummaryExperience: 'Experience',
  resumeSummaryEducation: 'Education',
  resumeSummaryAiAnalysis: 'AI Analysis',
  resumeSummaryRecency: 'Recent-fit insight',
  resumeSummaryStrengths: 'Strengths',
  resumeSummaryRisks: 'Risks',
  resumeSummaryNoAnalysis: 'No AI analysis available yet.',
  pipelineSubmitted: 'Screening',
  pipelineScreening: 'Outreach / Engaging',
  pipelineShortlisted: 'Submitted / Recommended',
  pipelineInterview: 'Interviewing',
  pipelineOffer: 'Offer Negotiation',
  pipelinePreOnboard: 'Offer Accepted / Pre-onboarding',
  pipelineOnboard: 'Hired / Onboarded',
  pipelineMore: 'More',
  pipelineRejectedScreening: 'Rejected – Screening',
  pipelineRejectedInterview: 'Rejected – Interview',
  pipelineOfferRejected: 'Offer Declined',
  pipelineSalaryNegotiationFailed: 'Salary Negotiation Failed',
  pipelineWithdrawn: 'Withdrawn',
  namePlaceholder: 'Enter job name (optional)',
  descPlaceholder: 'Enter job description (optional)',
  jdPlaceholder: 'Enter job JD (required)',
  createSuccess: 'Created successfully',
  updateSuccess: 'Updated successfully',
  deleteSuccess: 'Deleted successfully',
  confirmDelete: 'Are you sure you want to delete job "{name}"?',
  sidebarRenameTitle: 'Rename Job',
  sidebarNewName: 'Enter the new job name',
  retrySuccess: 'Retry submitted',
  statusToggleSuccess: 'Job status updated',
  bind: 'Bind Candidate',
  bindTitle: 'Bind Candidate to Job',
  bindToJob: 'Bind to Job',
  unbind: 'Unbind',
  remove: 'Remove',
  selectJob: 'Select Job',
  selectTag: 'Select Tag',
  selectCandidate: 'Select Candidate',
  bindNoJobTitle: 'No job specified',
  bindNoJobDesc: 'Open this dialog from a job row to bind candidates to that job.',
  bindTagMultiTitle: 'Select one or more candidate tags',
  bindSelectedTagCount: '{count} tag(s) selected',
  bindTagPlaceholder: 'Select tags, multiple allowed',
  bindFilterTitle: 'Use filters to define the candidate pool',
  bindFilterNote:
    'Candidates matching the selected tags and filters will be fetched and bound to the current job.',
  bindUiConfirmSuccess: 'Filters and tags confirmed',
  bindNoCandidates: 'No candidates match the current filters',
  bindResult: 'Binding finished. {success} succeeded, {failed} failed',
  bindFilters: {
    nationality: 'China Fit',
    nationalityAll: 'All',
    nationalityChinese: 'China-related',
    nationalityNonChinese: 'Other / Unknown',
    language: 'Language',
    languagePlaceholder: 'Select languages',
    function: 'Function',
    functionPlaceholder: 'Select functions',
  },
  bindSuccess: 'Bind succeeded',
  unbindSuccess: 'Unbind succeeded',
  refresh: 'Refresh',
  boundCandidate: 'Candidate',
  boundStatus: 'Analysis Status',
  resumeParseTitle: 'Resume Parsing',
  resumeParseSubtitle: 'Upload PDF resumes in batch and submit them to the current job',
  resumeParseFormatPdf: 'PDF Resume',
  resumeParseFormatWord: 'Word Resume',
  resumeParseFormatImage: 'Image Resume',
  resumeParseUploadTitle: 'Upload Resume Files',
  resumeParseUploadHint: 'Click or drag PDF files here',
  resumeParseUploadTip: 'Multiple files supported, up to 500 per batch',
  resumeParseScopeTitle: 'Parsing Scope',
  resumeParseSourceRemark: 'Source Note',
  resumeParseSourceRemarkPlaceholder:
    'e.g. LinkedIn batch import, campus site, referral collection',
  resumeParseScopeNote: 'This note is submitted with the batch for later filing and tracking.',
  resumeParseMetaTitle: 'Parsing Overview',
  resumeParseMetaEmpty: 'Upload files to see parsing overview',
  resumeParseQualityEmpty: 'Quality score appears after parsing',
  resumeParseUploadAssistTitle: 'Upload Notes',
  resumeParseUploadAssistDesc: 'Drag or click to upload, up to 500 files per batch.',
  resumeParseUploadAssistTip1: 'Use clear scans for images to improve OCR quality',
  resumeParseUploadAssistTip2: 'Keep text layer intact for PDF/Word files',
  resumeParseUploadAssistTip3: 'Parsed fields are editable and synced to JSON',
  resumeParseUploadAssistFlowTitle: 'Parsing Flow',
  resumeParseUploadAssistFlow1: 'Upload files',
  resumeParseUploadAssistFlow2: 'Parse structure',
  resumeParseUploadAssistFlow3: 'Edit and save',
  resumeParseSelected: '{count} file(s) selected',
  resumeParseClear: 'Clear',
  resumeParseStart: 'Start Parsing',
  resumeParseLimit: 'Up to 500 files per batch',
  resumeParseFolderUpload: 'Select Folder',
  resumeParsePdfOnly: 'Only PDF resumes are supported for now',
  resumeParseFileTooLarge: 'Each PDF file must be 5MB or smaller',
  resumeParseJobMissing: 'Missing job ID. Please reopen this page from the job list',
  draftJobImportDisabled:
    'Draft jobs cannot import candidates. Please finish creating the job first.',
  resumeParseUploadSubmitted: '{count} resume(s) submitted. Parsing in background.',
  resumeParseQueued: 'Parsing queued',
  resumeParseCompleted: 'Parsing complete. JSON preview generated.',
  resumeParseFailed: 'Parsing failed. Please retry or switch files.',
  resumeParseSignFailed: 'Failed to get upload authorization for {name}. Please retry.',
  resumeParseUploadFailed: 'Failed to upload {name}. Please retry.',
  resumeParseFileInvalid: 'Invalid file metadata for {name}. Please reselect the file.',
  resumeParseCurrentFile: 'current file',
  resumeParseFileMissing: 'Cannot read files. Please reselect.',
  resumeParseResultTitle: 'Parsed Structure',
  resumeParseVisualTitle: 'Visual Preview',
  resumeParseResultJson: 'JSON Preview (Full)',
  resumeParseResultEmpty: 'Upload files and click “Start Parsing” to generate preview',
  resumeParseStatusIdle: 'Waiting',
  resumeParseStatusParsing: 'Parsing',
  resumeParseStatusReady: 'Ready',
  resumeParseWarnings: 'Parsing Notes',
  resumeParseQuality: 'Quality',
  resumeParseEdit: 'Edit',
  resumeParseEditDone: 'Done',
  resumeParseEditTip: 'Please parse resumes first',
  resumeParseExpand: 'Expand',
  resumeParseCollapse: 'Collapse',
  resumeParseCopyJson: 'Copy JSON',
  resumeParseDownloadJson: 'Download JSON',
  resumeParseCopySuccess: 'JSON copied',
  resumeParseCopyFailed: 'Copy failed',
  resumeParseSections: {
    basic: 'Basic Info',
    education: 'Education',
    internship: 'Internship',
    experience: 'Work Experience',
    honor: 'Honors & Awards',
    skill: 'Skills & Certificates',
    project: 'Projects',
  },
  createFlow: {
    backToList: 'Back to job list',
    steps: {
      input: '1. Enter JD',
      review: '2. Review parsed result',
    },
    defaultGreetingName: 'there',
    placeholder:
      'Please paste the full JD, for example:\nLead the overseas sales team, expand the Singapore and Southeast Asia market, and focus on semiconductor equipment clients;\nRequire 3-5+ years of industry experience, fluent English for work, and strong account management and technical communication skills.',
    suggestions: {
      item1: 'Software engineers in SF at Series B companies, skilled in Python and Node.js',
      item2: 'Marketing manager in Europe, German-speaking, with experience in large enterprises',
      item3: 'Senior scientist in Australia with 8+ years of experience',
      item4: 'Consultant in London with 2+ years at top consulting firms',
      item5:
        'Sales director based in Singapore in the semiconductor equipment industry, leading Southeast Asia expansion',
    },
    signals: {
      location: 'Location',
      jobTitle: 'Job Title',
      yearsOfExperience: 'Years of Experience',
      industry: 'Industry',
      skills: 'Skills',
    },
    input: {
      title: 'Hey {name}, who are you looking for?',
      subtitle:
        'Paste a JD or describe the role, and AI will generate a search strategy and candidate recommendations.',
      jobDescription: 'Job Description',
      analyze: 'Parse JD',
      suggestionsTitle: 'Example prompts',
      suggestionsSubtitle:
        'Start from one of these examples, then edit it into your own job description.',
    },
    analysis: {
      kicker: 'EasyHire AI Parsing',
      waitingInput: 'Waiting for JD input...',
      inputLabel: 'JD Input',
      outputLabel: 'AI Output',
      outputItem1: 'Candidate job titles and function root',
      outputItem2: 'Location / industry / experience / keywords',
      outputItem3: 'Screening weights and evaluation framework',
    },
    analysisSteps: {
      step1: {
        title: 'Understanding the JD',
        short: 'Role, location, and core context',
        description:
          'AI is breaking down the raw JD text to extract the job title, work location, company context, and key responsibilities.',
      },
      step2: {
        title: 'Extracting screening signals',
        short: 'Experience, industry, keywords, and weights',
        description:
          'AI is organizing experience ranges, industry constraints, keywords, and weights to form an actionable hiring profile.',
      },
      step3: {
        title: 'Building the evaluation framework',
        short: 'Must-haves, nice-to-haves, and scoring focus',
        description:
          'AI is constructing the evaluation framework so HR can screen faster and calibrate manually when needed.',
      },
    },
    generating: {
      step1: 'Understanding your hiring intent...',
      step2: 'Extracting key signals:',
      step3: 'Inferring role expectations:',
      step4: 'Building evaluation criteria...',
      step5: 'Finalizing structured requirements...',
      jobTitle: 'Job Title',
      jobTitleValue: 'Sales Manager',
      location: 'Location',
      locationValue: 'United States',
      industry: 'Industry',
      industryValue: 'Consumer Electronics',
      level: 'Level',
      levelValue: 'Manager',
      experience: 'Experience',
      experienceValue: '5-10 years',
    },
    review: {
      sidebarKicker: 'Confirm the job profile',
      sidebarTitle: 'Edit Your Job Profile',
      sidebarDesc:
        'Review the screening conditions parsed by AI and adjust them if needed before creating the job.',
      searchGroups: 'Search field groups',
      quickNav: 'Jump to a section',
      currentMock: 'Current mock sample',
      mockIndicator: 'Group {index} / {total}',
      switchMock: 'Switch to next mock result',
      summaryCount: '{count} conditions',
      backToInput: 'Back to JD input',
      create: 'Create job',
      update: 'Save changes',
      unnamedJob: 'Untitled job',
      notIdentified: 'Not identified',
      sections: {
        general: 'General',
        location: 'Location & Experience',
        job: 'Job & Keywords',
        industry: 'Industry',
        weights: 'Weights',
        framework: 'Framework',
        source: 'Original JD',
      },
      summary: {
        titleSuggestion: 'Suggested job title',
        editable: 'Editable',
        coreLocation: 'Core location',
        coreIndustry: 'Core industry',
        experienceRange: 'Experience range',
        weight: 'Weight {value}',
        level: 'Level {value}',
      },
      general: {
        title: 'General job information',
        jobName: 'Job name',
        jobNamePlaceholder: 'Enter job name',
        functionRoot: 'Function root',
        functionRootPlaceholder: 'Enter function root',
        domain: 'Job domain',
        domainPlaceholder: 'Enter job domain',
        description: 'Job notes',
        descriptionPlaceholder: 'Add notes for your team about this role',
      },
      location: {
        title: 'Location and experience range',
        workLocation: 'Work location',
        workLocationPlaceholder: 'Enter work location',
        ageRange: 'Age range',
        ageRangePlaceholder: 'For example 25-38',
        experience: 'Experience requirement',
        experiencePlaceholder: 'For example 3-5 years',
        seniority: 'Seniority',
        seniorityPlaceholder: 'Enter seniority',
      },
      job: {
        title: 'Candidate titles and keywords',
        titles: 'Candidate job titles',
        titlesPlaceholder: 'One title per line',
        keywords: 'Keywords',
        keywordsPlaceholder: 'One keyword per line',
      },
      industry: {
        title: 'Industry information',
        primary: 'Primary industry',
        primaryPlaceholder: 'Enter primary industry',
        secondary: 'Secondary industry',
        secondaryPlaceholder: 'One secondary industry per line',
      },
      weights: {
        title: 'Screening weights',
        domain: 'Domain',
        language: 'Language',
        age: 'Age',
      },
      framework: {
        title: 'Evaluation framework',
        mergedLabel: 'Evaluation framework details',
        mergedPlaceholder:
          'One item per line, for example:\nRole Summary: Own semiconductor client development in Southeast Asia\nMust-have Criteria: 3+ years of semiconductor equipment sales experience\nPreferred Criteria: Existing client network in Singapore\nInferred Criteria: Able to drive complex client negotiations independently\nScoring Focus: Industry relevance and client development ability',
        roleSummary: 'Role summary',
        roleSummaryPlaceholder: 'Enter role summary',
        mustHave: 'Must-have criteria',
        mustHavePlaceholder: 'One must-have criterion per line',
        preferred: 'Preferred criteria',
        preferredPlaceholder: 'One preferred criterion per line',
        inferred: 'Inferred criteria',
        inferredPlaceholder: 'One inferred criterion per line',
        scoringFocus: 'Scoring focus',
        scoringFocusPlaceholder: 'One scoring focus per line',
      },
      source: {
        title: 'Original JD',
      },
    },
    workspace: {
      sourceLabel: 'Analysis Source:',
      interpretedTitle: 'EasyHire AI has organized your input into a structured hiring profile',
      priorityTitle: 'What will matter most in matching',
      whyTitle: 'Why AI structured it this way',
      criteriaTitle: 'Evaluation Criteria',
      criteriaInputPlaceholder: 'Enter evaluation criteria...',
      addCriteriaAction: 'Add Criteria',
      criteriaAction: 'Edit Criteria',
      confirmedTitle: 'Confirmed from input',
      inferredTitle: 'Inferred by AI',
      needConfirmTitle: 'Needs confirmation',
      mustHaveTitle: 'Must-have criteria',
      preferredTitle: 'Preferred criteria',
      refineAction: 'Refine requirements',
      refineTitle: 'Refine hiring needs',
      reanalyzeAction: 'Re-analyze job',
      reanalyzingAction: 'Re-analyzing...',
      saveChangesAction: 'Save changes',
      savingAction: 'Saving changes and re-analyzing...',
      savingHint:
        'Submission usually completes within 15 seconds. The latest JD is already shown and results will refresh next.',
      originalInputLabel: 'Current analysis text',
      filterSummary: 'Role summary',
      criteriaFocus: 'Current screening focus',
      refinePlaceholder:
        'You can edit or append to the original JD here, for example: only look in Shanghai and require AI design capability',
      defaultNeedConfirm: 'Team scope, reporting line, and business stage',
      criteriaGroups: {
        mustHave: 'Must-have',
        niceToHave: 'Nice to have',
        risk: 'Risk item - matching this makes the score fail',
      },
      editorResizeHint: 'Drag the bottom-right corner to resize the editor',
      groups: {
        coreRole: 'Group A: Core role definition',
        background: 'Group B: Background and business context',
        skills: 'Group C: Keywords and screening signals',
        optional: 'Group D: Preferred and inferred signals',
      },
      fields: {
        roleSummary: 'Role summary',
        mustHave: 'Must-have criteria',
        preferred: 'Preferred criteria',
        inferred: 'Inferred criteria',
        scoringFocus: 'Scoring focus',
      },
      quickAdditions: {
        title: 'Quick add common requirements',
        item1: 'Experience building teams from 0 to 1',
        item2: 'Cross-region client development experience',
        item3: 'Comfortable with fast-growth business pace',
      },
      priorities: {
        jobTitle: 'Job title relevance',
        function: 'Function fit',
        industry: 'Industry relevance',
        skills: 'Keywords / domain signals',
        level: 'Seniority and experience fit',
        language: 'Language / regional background',
      },
      priorityLevels: {
        high: 'High',
        medium: 'Medium',
        optional: 'Optional',
      },
    },
    messages: {
      enterJdFirst: 'Please enter or paste the job JD first',
      mockGenerated: 'Generated the job parsing result from mock data',
      mockSwitched: 'Switched to mock parsing result group {index}',
      confirmJobName: 'Please confirm the job name first',
      enterRefineMessage: 'Please enter refinement instructions before re-analysis',
      refineUpdated: 'Job requirements updated',
      createSubmitted:
        'Save submitted. We are processing it in the background and refreshing job analysis',
    },
  },
}

export default jobs
